import { HeaderSide } from "./headerside"
import style from './style.module.css'
import { MapWithPoligons } from "../../MapWithPoligons";
import L from "leaflet";
import { Table } from "./Table";
import { Graph1 } from "./graph1";
import { Graph2 } from "./graph2";

const customMarkerIcon = L.icon({
    iconUrl: "/imort.svg",
    iconSize: [35, 55],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
  });


export const TreeTwo = () => {
   
    const staticMarker = [
        {
            latitude: 42.8746,
            longitude: 74.5698,
            name: "ОсОО «Кыргыз Мясопродукт»",
            popupContent: `
              <div style="font-family: Montserrat, Arial, sans-serif; max-width: 320px;">
                <div style="font-size: 20px; font-weight: 600; margin-bottom: 12px;"></div>
                <div style="margin-bottom: 8px;"><b>Количество фермеров:</b> 49 </div>
                <div style="margin-bottom: 8px;"><b>Количество задач:</b> 18</div>
                <hr style="margin: 10px 0;">
                <div style="margin-bottom: 8px;"><b>Выполнено:</b> 3</div>
                <div style="margin-bottom: 8px;"><b>Не требуется:</b> 0</div>
                <div style="margin-bottom: 8px;"><b>Не выполнено:</b> 12</div>
              </div>
            `
          }
    ];
    return (
        <div >
        <HeaderSide />
        <div className={style.container}>
            <div className={style.map}>
            <div className={style.content}>
                <MapWithPoligons
                     extraData={staticMarker}
                              latitude={41.5089324}
                              longitude={74.724091}
                              customIcon={customMarkerIcon}
                              type = {["REGION"]}
                />
            </div>
            {/* <div className={style.table}>
                <Table />
            </div> */}
            </div>
        </div>
        <div className={style.graphs}>
        <div className={style.graph1}>
            <Graph1 />
        </div>
        <div className={style.graph2}>
            <Graph2 />
        </div>
        </div>
        </div>
    )
}